<template>
	<div class="news_contain">
		<van-list
			v-model="loading"
			:finished="finished"
			:finished-text="finishedtext"
			:immediate-check="false"
			@load="initData"
		>
			<div class="flexs every_news mb-16" v-for="(item, index) in list" :key="index" @click="getDetail(item.id)">
				<van-image :src="item.picture" :lazy-load="true">
					<template v-slot:error>
						<img class="wh_36 b-radius-6" src="../../assets/img/icon/error.png" alt="">
					</template>
				</van-image>
				<div class="flex1">
					<div class="c1 fz-16 fw-500 w192 text-hide">{{item.title}}</div>
					<div class="news_txt text-hide fz-12 c2">{{item.title_content? item.title_content: '暂无消息'}}</div>
				</div>
				<img class="icon_img" v-if="item.is_top" src="../../assets/img/icon/news_icon.png" alt="">
				<div class="cicle" v-if="!item.is_read"></div>
			</div>
		</van-list>
		

		<noData v-if="show"></noData>
		<loading :loadFlag="loadFlag"></loading>
	</div>

</template>
<script>
	import { getCode } from '@/utils/wx'
	import loading from "@/components/loading"
  import { messageList } from "@/api/api.js"
  import noData from "@/components/noData"
	import { getList } from '@/utils/common'
	export default {
		components: {
      noData,
			loading
		},
		data() {
			return {
				list: [],
				loading: false,
				finished: false,
				page: 1,
				show: false,
				finishedtext: '',
				loadFlag: false
			};
		},
		created() {
			const searchParams = new URLSearchParams(window.location.search)
    	const urlCode = searchParams.get('code')
			if(urlCode){
        getCode().then(()=>{
          this.initData()
				}).catch(()=>{})
			} else {
        this.initData()
			}
		},
		methods: {
			getDetail(id){
				getCode().then(()=>{
          this.$router.push({ path:'/newsdetail', query: {id} })
				}).catch(()=>{})
				
			},

			initData(){
				getList(this, messageList, { page: this.page })
			}
		}
	}
</script>
<style lang="less" scoped>
	.news_contain {
		padding: 20px 16px 10px;

		.every_news {
			position: relative;
			height: 76px;
			background: #FFFFFF;
			box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.02);
			border-radius: 6px;
			padding: 10px 20px 10px 15px;

			&:last-child{
				margin-bottom: 0;
			}


			.cicle {
				width: 7px;
				height: 7px;
				background: #FF3C3C;
				box-shadow: 0px 0px 2px 0px rgba(255, 60, 60, 0.2);
				border-radius: 50%;
			}

			/deep/.van-image {
				width: 56px;
				height: 56px;
				border-radius: 6px;
				margin-right: 14px;
			}

			.icon_img {
				position: absolute;
				top: 0;
				right: 0;
				width: 28px;
				height: 31px;
			}

			.news_txt {
				width: 192px;
				margin-top: 10px;
			}
		}


	}

	/deep/.van-list__finished-text {
		line-height: 10px !important;
	}

	/deep/.van-list__loading {
    // line-height: 10px !important;
		display: none;
	}
</style>
